var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ci-content-hub--nav-item",
      class: [_vm.borderClass, _vm.paddingClass],
    },
    [
      _c(
        "div",
        {
          staticClass:
            "header d-flex justify-content-between align-items-center",
        },
        [
          _c("div", {
            staticClass: "title px-2 py-1 w-100",
            class: { active: _vm.active },
            domProps: { textContent: _vm._s(_vm.navItem.title) },
            on: { click: _vm.redirectToContentHub },
          }),
          _vm.expandable
            ? _c("div", {
                staticClass: "indicator d-flex align-items-center mdi px-2",
                class: {
                  "mdi-chevron-down": !_vm.expanded,
                  "mdi-chevron-up": _vm.expanded,
                },
                on: { click: _vm.toggleExpand },
              })
            : _vm._e(),
        ]
      ),
      _vm.expanded && _vm.expandable
        ? _c(
            "div",
            { staticClass: "nested-content-routes" },
            _vm._l(_vm.nestedContentRoutes, function (route) {
              return _c("content-hub-nav-item", {
                key: route.slug,
                attrs: { "nav-item": route, nested: true },
              })
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }